/*
 * Copyright (C) 2019 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { LoadableState, defaultLoadableState } from '@opengamma/ui';
import { NamedValue } from 'app/shared/models';

/** Static data state. */
export interface StaticDataState {
  calcRunType: LoadableState<NamedValue<string>[]>;
  ccp: LoadableState<NamedValue<string>[]>;
  configType: LoadableState<NamedValue<string>[]>;
  currency: LoadableState<NamedValue<string>[]>;
  customReportType: LoadableState<NamedValue<string>[]>;
  fileFormat: LoadableState<NamedValue<string>[]>;
  fileType: LoadableState<NamedValue<string>[]>;
  filter: LoadableState<NamedValue<string>[]>;
  outputConverterType: LoadableState<NamedValue<string>[]>;
  outputGrouping: LoadableState<NamedValue<string>[]>;
  portfolioMarginModel: LoadableState<NamedValue<string>[]>;
  reportingCalcMeasure: LoadableState<NamedValue<string>[]>;
  reportingCurrency: LoadableState<NamedValue<string>[]>;
  reportPostProcessorType: LoadableState<NamedValue<string>[]>;
  emailType: LoadableState<NamedValue<string>[]>;
}

/** Initial static data state. */
export const INITIAL_STATE: StaticDataState = {
  calcRunType: {
    loading: false,
    data: [
      { name: 'Overnight', value: 'OVERNIGHT' },
      { name: 'Intra-day', value: 'INTRADAY' }
    ],
    error: undefined
  },
  ccp: defaultLoadableState(),
  configType: defaultLoadableState(),
  currency: defaultLoadableState(),
  customReportType: defaultLoadableState(),
  fileFormat: defaultLoadableState(),
  fileType: defaultLoadableState(),
  filter: defaultLoadableState(),
  outputConverterType: defaultLoadableState(),
  outputGrouping: defaultLoadableState(),
  portfolioMarginModel: defaultLoadableState(),
  reportingCalcMeasure: defaultLoadableState(),
  reportingCurrency: defaultLoadableState(),
  reportPostProcessorType: defaultLoadableState(),
  emailType: defaultLoadableState()
};
